export default __webpack_public_path__ + "static/media/expl-nn_02_EN.86637b81.png";